import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AnimatedSprite} from "./AnimatedSprite";

// Constructor
export class Bird extends AnimatedSprite {

  constructor(x, y, asset, appearingScreenPercent, game) {
    super(x, y, asset, appearingScreenPercent, game);

    this.pos = {
      x: x,
      y: y
    }
  }

  buildAnimations() {
    this.inAnimation = gsap.fromTo(this,
      {
        pixi: {
          scale: 0.0
        }
      },
      {
        pixi: {
          scale: 1.0
        },
        ease: "back.out(1.5)",
        immediateRender: true, // makes the bird scale 0 immediately, even if tween is paused
        paused: true,
        duration: 0.5,
        onComplete: this.animate.bind(this), // start the animation loop once animated in
      }
    );

    this.mainAnimation = gsap.timeline({
      paused: true,
      repeat: -1,
      yoyo: true,
      delay: window.getRandomFloat(0, 0.1) // add a random delay before it starts so not all the birds are in sync
    });

    this.mainAnimation.fromTo(this,
      {
        pixi: {
          y: this.pos.y
        },
      },
      {
        pixi: {
          y: this.pos.y - 20
        },
        ease: "sine.inOut",
        duration: 2
      }
    );
  }

}
